import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=b410566a&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b410566a')) {
      api.createRecord('b410566a', component.options)
    } else {
      api.reload('b410566a', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=b410566a&", function () {
      api.rerender('b410566a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27QB7kIt6xtbl/JS/comp/ImgFallback2.vue"
export default component.exports